<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <RecorderVoice
      v-model="voice"
    />
  </q-dialog>
</template>

<script>
import RecorderVoice from './RecorderVoice'

export default {
  components: {
    RecorderVoice
  },

  data () {
    const voice = null
    return { voice }
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      this.$emit('hide')
    },

    onOKClick (voice) {
      this.$emit('ok', voice)
      this.hide()
    },

    onCancelClick () {
      this.hide()
    }
  },

  watch: {
    voice: {
      deep: true,
      handler (voice) {
        if (voice) this.onOKClick(voice)
      }
    }
  }
}
</script>
